
import React, { useState, useEffect } from 'react';
//import axios from 'axios';
import { jwtDecode } from 'jwt-decode';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import { Buffer } from 'buffer';
import process from 'process/browser';
import Alert from './Alert';
import LanguageSelector from './LanguageSelector';
import '../styles/Settings.css'; 

import api from '../services/api';
import { provisionIfNeeded, base64ToBuffer } from '../services/signalManager';
import { hasLocalIdentity as checkHasLocalIdentity } from '../services/signalManager';

import { Eye, EyeOff } from 'lucide-react'; 

import { encryptPrivateKey, recoverPrivateKey } from '../utils/e2eeRecovery';
import RecoveryPhraseBackup from './RecoveryPhraseBackup';
import RecoveryPhraseInput from './RecoveryPhraseInput';
import { signalStore, purgeSessionsAndPreKeys } from '../services/signalStore';
import { toArrayBuffer } from '../services/signalCrypto';
import { refreshPreKeysAfterRecovery } from '../services/signalManager';
import { requestSessionResetForAll } from '../services/signalGroupCrypto';




if (typeof global !== 'undefined') {
  global.Buffer = Buffer;
  global.process = process;
} else if (typeof window !== 'undefined') {
  window.Buffer = Buffer;
  window.process = process;
}


function Connexion({ onLogin, userLang }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [error, setError] = useState('');
  const [err, setErr] = useState('');

  const [success, setSuccess] = useState('');
  const [isRegistering, setIsRegistering] = useState(false);
 const [showForgotPassword, setShowForgotPassword] = useState(false);
const [showPassword, setShowPassword] = useState(false);

const [recoveryMode, setRecoveryMode] = useState(false);
const [recoveryNotice, setRecoveryNotice] = useState('');



  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

const [turnstileToken, setTurnstileToken] = useState('');
const turnstileRef = React.useRef(null);
const widgetIdRef = React.useRef(null);
const [passwordErrors, setPasswordErrors] = useState([]);

const [showRecoveryBackup, setShowRecoveryBackup] = useState(false);
  const [showRecoveryInput, setShowRecoveryInput] = useState(false);
  const [recoveryPhrase, setRecoveryPhrase] = useState('');
  const [privateKey, setPrivateKey] = useState(null); // ✅ Nouveau: stocke la clé privée
const [loggedUser, setLoggedUser] = useState(null);

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

  useEffect(() => {
  setSuccess(''); // Efface le précédent message de succès
  const params = new URLSearchParams(location.search);
  const message = params.get('message');
  const localMsg = localStorage.getItem('verifiedMessage');

  if (message) {
    setSuccess(message);
  } else if (localMsg) {
    setSuccess(localMsg);
    localStorage.removeItem('verifiedMessage');
  }
}, [location]);

useEffect(() => {
  if (sessionStorage.getItem('resumeLogin') !== '1') return;
  const token = localStorage.getItem('token');
  if (!token) return;

  const recovery = sessionStorage.getItem('pendingRecovery') === 'true';
  sessionStorage.removeItem('resumeLogin');
  sessionStorage.removeItem('pendingRecovery');

  let user = null;
  try { user = JSON.parse(localStorage.getItem('user') || 'null'); } catch { /* ignoré */ }
  if (!user) return;

  api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  finishLogin(user, { recovery }).catch((err) => {
    console.error('Reprise de connexion :', err);
    setError(t('connexion.erreur_connexion'));
  });
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);


useEffect(() => {
    if (success) {
      const timer = setTimeout(() => {
        setSuccess(''); // Efface le message après 5 secondes
      }, 5000);

      return () => clearTimeout(timer); // Nettoyage si le composant se démonte ou si le message change
    }
  }, [success]);

// Nouveau useEffect pour charger le widget quand on passe en mode inscription
useEffect(() => {
  if (isRegistering && window.turnstile && turnstileRef.current && !widgetIdRef.current) {
    try {
      widgetIdRef.current = window.turnstile.render(turnstileRef.current, {
        sitekey: process.env.REACT_APP_TURNSTILE_SITE_KEY,
        callback: (token) => setTurnstileToken(token),
        'expired-callback': () => setTurnstileToken(''),
        'error-callback': (err) => {
          console.warn('Turnstile error-callback:', err);
          setTurnstileToken('');
        }
      });
    } catch (err) {
      console.error('Erreur render Turnstile:', err);
    }
  }

  return () => {
    if (widgetIdRef.current && window.turnstile) {
      try {
        window.turnstile.remove(widgetIdRef.current);
      } catch (e) {}
      widgetIdRef.current = null;
    }
  };
}, [isRegistering]);

const COMMON_PASSWORDS = [
  'password', '123456', '12345678', 'azerty', 'qwerty',
  'motdepasse', 'password1', '11111111', 'abc123456'
];

const checkPasswordStrength = (pwd, currentEmail, currentUsername) => {
  const errors = [];
  if (pwd.length < 12) errors.push(t('password.tooShort'));
  if (!/[A-Z]/.test(pwd)) errors.push(t('password.needUppercase'));
  if (!/[a-z]/.test(pwd)) errors.push(t('password.needLowercase'));
  if (!/[0-9]/.test(pwd)) errors.push(t('password.needNumber'));
  if (!/[^A-Za-z0-9]/.test(pwd)) errors.push(t('password.needSpecialChar'));

  const lowerPwd = pwd.toLowerCase();
  if (COMMON_PASSWORDS.some(common => lowerPwd.includes(common))) {
    errors.push(t('password.tooCommon'));
  }
  const emailLocalPart = currentEmail.split('@')[0]?.toLowerCase();
  if (emailLocalPart && lowerPwd.includes(emailLocalPart)) {
    errors.push(t('password.containsEmail'));
  }
  if (currentUsername && lowerPwd.includes(currentUsername.toLowerCase())) {
    errors.push(t('password.containsUsername'));
  }

  setPasswordErrors(errors);
  return errors.length === 0;
};

const handleEmailChange = (e) => {
  const val = e.target.value;
  setEmail(val);
  if (password) checkPasswordStrength(password, val, username);
};

const handleUsernameChange = (e) => {
  const val = e.target.value;
  setUsername(val);
  if (password) checkPasswordStrength(password, email, val);
};

const handlePasswordChange = (e) => {
  const val = e.target.value;
  setPassword(val);
  checkPasswordStrength(val, email, username);
};
// Gestion du mot de passe oublié : envoi mail avec mot de passe temporaire
  const handleForgotPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    try {
      await api.post(`${API_URL}/api/users/forgot-password`, { email, lang: i18n.language });
      setSuccess(t('connexion.forgot_password_success'));  // à ajouter dans i18n
      setShowForgotPassword(false);
    } catch (err) {
      const message = err.response?.data?.message || t('connexion.error');
      setError(message);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
if (!turnstileToken) {
    setError(t('connexion.captcha_required')); // à ajouter dans vos fichiers i18n
    return;
  }
if (passwordErrors.length > 0) {
setError(t('password.faible')); // à ajouter dans vos fichiers i18n
    return;

}
    try {
      const response = await api.post(`${API_URL}/api/users/register`, {
        email,
        password,
        username,
lang: i18n.language,
turnstileToken
      });

      const code = response?.data?.code;
      const message = t(code);
      setSuccess(message);
      setIsRegistering(false);
    } catch (err) {
      const code2 = err.response?.data?.code2;
      const message2 = t(code2);
      setError(message2 || t('connexion.error'));
	// Réinitialise le captcha après un échec, il ne peut servir qu'une fois
    if (window.turnstile && widgetIdRef.current) {
      window.turnstile.reset(widgetIdRef.current);
    }
	setTurnstileToken('');
    }
  };

// Fonction pour basculer vers la récupération



const handleGoToRecovery = () => {
  setRecoveryMode(true);
  setRecoveryNotice(
    t('recoveryinput.recover')
  );

  setError('');
  setShowRecoveryInput(false);
  setShowRecoveryBackup(false);
};

// ✅ Fonction pour gérer la génération et sauvegarde de la phrase
  const handleFirstLogin = async () => {
  try {
    const identityKey = await signalStore.get('identityKey');
const registrationId = await signalStore.get('registrationId');
    const signedPreKey = await signalStore.get('signedPreKey');


    if (!identityKey?.privKey) {
      throw new Error('Clé privée introuvable');
    }

if (!signedPreKey?.keyPair?.privKey) {
      throw new Error('Signed PreKey introuvable');
    }

    setPrivateKey({
      identityKey,
      registrationId,
      signedPreKey,
    });

    //setPrivateKey(identityKey.privKey);
    setShowRecoveryBackup(true);

  } catch (err) {
    console.error('❌ Erreur préparation récupération:', err);

    setError(
      err.message ||
      'Impossible de préparer la récupération E2EE'
    );
  }
};

const abortLogin = (message) => {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshToken');
  localStorage.removeItem('user');
  delete api.defaults.headers.common['Authorization'];
  setError(message);
};

const finishLogin = async (user, { recovery = false } = {}) => {
  setLoggedUser(user);

  if (recovery) {
    setShowRecoveryInput(true);
    return;
  }

  const hasLocalIdentity = await checkHasLocalIdentity();

  // Source de vérité : le serveur. Dans le doute, on ne crée RIEN.
  let hasRecovery = user.e2eeRecoveryConfigured;
  if (hasRecovery === undefined) {
    try {
      hasRecovery = !!(await api.get('/api/e2ee/recovery/status')).data?.configured;
    } catch {
      abortLogin(t('connexion.erreur_connexion'));
      return;
    }
  }

  if (hasLocalIdentity && !hasRecovery) {
    await handleFirstLogin(user);
    return;
  }
  if (!hasLocalIdentity && hasRecovery) {
    setShowRecoveryInput(true);
    return;
  }

  if (!hasLocalIdentity && !hasRecovery) {
    // Une identité est peut-être déjà publiée (autre appareil) : ne jamais l'écraser sans accord
    let serverHasKeys;
    try {
      serverHasKeys = !!(await api.get('/api/signal/prekeys/status')).data?.hasKeys;
    } catch {
      abortLogin(t('connexion.erreur_connexion'));
      return;
    }

    if (serverHasKeys) {
      const ask = (m) => Promise.resolve(window.confirm(m));
      const ok = await ask(t('connexion.reset_identite_confirm'));
      if (!ok) {
        abortLogin(t('connexion.reset_identite_refuse'));
        return;
      }
      await provisionIfNeeded({ confirmReset: true });
    } else {
      await provisionIfNeeded();
    }
    await handleFirstLogin(user);
    return;
  }

  onLogin(user);
  navigate('/');
};

const handleSubmit = async (e) => {
  e.preventDefault();
  setError('');
  setSuccess('');

  // 🔐 Mode récupération E2EE
  // Les identifiants sont obligatoires
  if (recoveryMode && (!email.trim() || !password)) {
    setError(
      '🔐 Pour récupérer votre compte E2EE, veuillez renseigner votre email et votre mot de passe.'
    );
    return;
  }

  try {
    const response = await api.post(`${API_URL}/api/users/login`, {
      email,
      password,
      userLang
    });

    // 🔐 2FA
    if (response.data.twoFactorRequired) {
      localStorage.setItem('tempToken', response.data.tempToken);

      // On mémorise qu'il s'agit d'une récupération E2EE
      if (recoveryMode) {
        sessionStorage.setItem('pendingRecovery', 'true');
      }

      navigate('/2fa');
      return;
    }

    const { token, refreshToken, user } = response.data;

    if (!token || !refreshToken) {
      throw new Error('Token manquant côté serveur');
    }

    localStorage.setItem('token', token);
    localStorage.setItem('refreshToken', refreshToken);
    localStorage.setItem('user', JSON.stringify(user));
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    //setLoggedUser(user);
    await finishLogin(user, { recovery: recoveryMode });
    //api.defaults.headers.common['Authorization'] = `Bearer ${token}`;

    // =========================================================
    // 🔐 MODE RÉCUPÉRATION E2EE
    // =========================================================
    if (recoveryMode) {
      
      setShowRecoveryInput(true);

      return;
    }

    // =========================================================
    // 🔐 CONNEXION NORMALE
    // =========================================================

   

const hasLocalIdentity = await checkHasLocalIdentity();


const hasRecovery = !!user.e2eeRecovery?.encryptedPrivateKey;


    if (hasLocalIdentity && !hasRecovery) {
      
      await handleFirstLogin(user);
      return;
    }

    if (!hasLocalIdentity && hasRecovery) {
      setShowRecoveryInput(true);
      return;
    }

    if (!hasLocalIdentity && !hasRecovery) {
      await provisionIfNeeded();
      await handleFirstLogin(user);
      return;
    }

    // identité locale + recovery déjà configurée
    onLogin(user);
    navigate('/');

  } catch (err) {
    console.error('Erreur login:', err);

    const backendCode = err.response?.data?.code;
    const status = err.response?.status;

    if (backendCode === 'connexion.account_locked') {
      const minutes = err.response.data.remainingMinutes;
      setError(
        t('connexion.account_locked', {
          remainingMinutes: minutes
        })
      );
    } else if (status === 429) {
      setError(
        err.response?.data?.message ||
        t('connexion.too_many_requests')
      );
    } else if (backendCode) {
      setError(t(backendCode));
    } else {
      setError(t('connexion.erreur_connexion'));
    }
  }
};



// ✅ Fonction pour récupérer le compte
const handleRecoverAccount = async (phrase) => {
  try {
    const response = await api.get(`${API_URL}/api/e2ee/recovery`);
    const recovered = await recoverPrivateKey(phrase, response.data);
//await purgeSessionsAndPreKeys();
    await signalStore.put('identityKey', recovered.identityKey);
    await signalStore.put('registrationId', recovered.registrationId);
    await signalStore.put('recoveredAt', Date.now());
    await refreshPreKeysAfterRecovery(recovered);

    setShowRecoveryInput(false);
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    onLogin(user);
    navigate('/');
  } catch (err) {
    console.error('❌ ERREUR RÉCUPÉRATION :', err.response?.status, err.message);
    throw err;
  }
};


const handleRecoveryPhraseConfirm = async (phrase) => {
  try {
    const encryptedData = await encryptPrivateKey(
      privateKey,
      phrase
    );

    await api.post(
      `${API_URL}/api/e2ee/recovery/setup`,
      encryptedData
    );

    setRecoveryPhrase(phrase);
    setShowRecoveryBackup(false);

    onLogin(loggedUser);
    navigate('/');

  } catch (err) {
    console.error(
      '❌ Erreur sauvegarde phrase:',
      err
    );

    throw err;
  }
};
const handleSkipRecovery = () => {
  setShowRecoveryBackup(false);
  setRecoveryMode(false);
  setRecoveryNotice('');
  
  onLogin(loggedUser);
  navigate('/');
};
  return (
    <div className="auth-container">

      <div className="title">{t('menu.titre')}</div>

  <div className="setting-item">
  <LanguageSelector />
  </div>

<Alert type="error" message={error} />
<Alert type="success" message={success} />
  {/* Affichage conditionnel mot de passe oublié */}
      {showForgotPassword ? (
        <div className="auth-form">
          <h2>{t('connexion.forgot_password_title')}</h2>
          <Alert type="error" message={error} />
          <Alert type="success" message={success} />
          <form onSubmit={handleForgotPassword} className="form-content">
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder={t('connexion.email')}
              className="form-input"
              required
            />
            <button type="submit" className="btn-primary">
              {t('connexion.send_temp_password')}
            </button>
          </form>
          <p>
            <button className="btn-secondary" onClick={() => setShowForgotPassword(false)}>
              {t('connexion.back_to_login')}
            </button>
          </p>
        </div>


     ) : isRegistering ? (
        <div className="auth-form">
          <h2>{t('connexion.registertitle')}</h2>
          <Alert type="error" message={error} />
          <Alert type="success" message={success} />
          <form onSubmit={handleRegister} className="form-content">
            <input type="email" value={email} onChange={handleEmailChange}placeholder={t('connexion.email')} className="form-input" required />
            <input type="text" value={username} onChange={handleUsernameChange} placeholder={t('connexion.username')} className="form-input" required />
            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={handlePasswordChange}
                placeholder={t('connexion.password')}
                className="form-input"
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Cacher le mot de passe' : 'Afficher le mot de passe'}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
{password && passwordErrors.length > 0 && (
  <ul style={{ fontSize: '12px', color: '#c0392b', paddingLeft: '18px', textAlign: 'left' }}>
    {passwordErrors.map((err, i) => <li style= {{ paddingTop: '5px', paddingBottom: '5px' }} key={i}>{err}</li>)}
  </ul>
)}

<div ref={turnstileRef} style={{ margin: '10px 0' }}></div>
            <button type="submit" className="btn-primary">{t('connexion.register')}</button>
          </form>
          <p>
            {t('connexion.alreadycompte')}{" "}
            <button className="btn-secondary" onClick={() => setIsRegistering(false)}>
              {t('connexion.connect')}
            </button>
          </p>
        </div>
      ) : (
        <div className="auth-form">
          <h2>{t('connexion.connexion')}</h2>
{recoveryNotice && (
  <Alert
    type="info"
    message={recoveryNotice}
  />
)}

          <Alert type="error" message={error} />
          <Alert type="success" message={success} />
          <form onSubmit={handleSubmit} className="form-content">
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder={t('connexion.email')} className="form-input" required />
            <div className="password-field">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder={t('connexion.password')}
                className="form-input"
                required
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
                aria-label={showPassword ? 'Cacher le mot de passe' : 'Afficher le mot de passe'}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>


            
<button
  type="submit"
  disabled={recoveryMode && (!email.trim() || !password)}
  className="btn-primary"
>
  {recoveryMode
    ? t('recoveryinput.recoverbutton')
    : t('connexion.connect')}
</button>


          </form>
	  <p>
            <button
              className="btn-secondary"
              onClick={() => setShowForgotPassword(true)}
              style={{ marginTop: '10px' }}
            >
              {t('connexion.forgot_password')}
            </button>
          </p>
          <p>
            {t('connexion.noaccount')}{" "}

            <button className="btn-secondary" onClick={() => setIsRegistering(true)}>
              {t('connexion.register')}
            </button>
          </p>
<p style={{ fontSize: '13px' }}>{t('connexion.mention')}</p>

        </div>
      )}
{/* ✅ Modals de récupération */}
      {showRecoveryBackup && (
<div className="modal-overlay">
    <div className="recovery-modal">
        <RecoveryPhraseBackup
  privateKey={privateKey}
  onConfirm={handleRecoveryPhraseConfirm}
 onSkip={handleSkipRecovery}
  onCancel={() => setShowRecoveryBackup(false)}
/>
</div>
  </div>

      )}

      {showRecoveryInput && (
<div className="modal-overlay">
    <div className="recovery-modal">
        <RecoveryPhraseInput
          onRecover={handleRecoverAccount}
          onCancel={() => setShowRecoveryInput(false)}
        />
</div>
  </div>

      )}
    </div>
  );
}

export default Connexion;
